import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=70a0ba38&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=70a0ba38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0ba38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a0ba38')) {
      api.createRecord('70a0ba38', component.options)
    } else {
      api.reload('70a0ba38', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=70a0ba38&scoped=true&", function () {
      api.rerender('70a0ba38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wMcPJoPmJQrS/JS/comp/DateRangeExt.vue"
export default component.exports